















import { Component, Prop, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
import {
  sortByShortDaysFn, isCurrentDay, fullDayName, ISOStringToLocalDate,
} from '@/utils/date-utils';
import { OperatingHoursModel } from '@/models/OperatingHoursModel';

@Component({
  methods: {
    isCurrentDay,
    fullDayName,
  },
})
export default class OperatingHours extends Vue {
  @Prop() private operatingHours!: OperatingHoursModel[];

  private get sortedHours(): OperatingHoursModel[] {
    return [...this.operatingHours].sort((a, b) => sortByShortDaysFn(a.day, b.day));
  }

  private hoursRange(obj: OperatingHoursModel) {
    if (!obj.open) return 'Closed';
    const open = ISOStringToLocalDate(obj.open);
    const close = ISOStringToLocalDate(obj.close);

    return `${format(open, 'hh:mm a')} - ${format(close, 'hh:mm a')}`;
  }
}
